<script>

export default {
  name: "ManageRequisitions",
  data() {
    return {
      requisitions: [],
      departments: [],
      search: ''

    }
  },
  computed: {
    sidebarData() {
      return this.$store.getters['sidebarData'];
    },
    filteredRequisitions() {
      if (!this.search) {
        return this.requisitions;
      }
      return this.requisitions.filter(requisition =>
          requisition.code.toString().includes(this.search.toLowerCase())
      );
    }
  },
  methods: {
    async getRequisitions() {
      try {
        let result = await this.$api.get("/auth/requisitions")
        if (result.status.toString() === "200") {
          this.requisitions = result.data
          if (this.requisitions === null) {
            this.requisitions = ''
          }
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la informació',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async getDepartments() {
      try {
        let res = await this.$api.get("/auth/departments");
        if (res.status.toString() === "200") {
          this.departments = res.data
        }
      } catch (error) {
        console.log("can't get departments data")
      }
    },
    async showRequisition(id) {
      this.$router.push({name: 'ShowRequisition', params: {id: id}})
    },
    getDepartmentsById(id) {
      return this.departments.find(department => department.id === id) || {}
    },
    async getReport() {
      const result = await this.$swal.fire({
        title: 'Reporte de consumo',
        html: `
            <lable>Seleccione el mes</lable>
            <input type="month" id="month"> </input>
        `,
        showCancelButton: true,
        confirmButtonText: 'Generar',
        customClass: {
          popup: 'mySwal'
        },
        preConfirm: () => {
          return [
              document.getElementById('month').value,
          ]
        }
      });
      if (result.value && result.isConfirmed) {
        const dateString = result.value[0]; // Format: "YYYY-MM"
        const [year, month] = dateString.split('-');


        let formData = new FormData();

        formData.append('month', month);
        formData.append('year', year);

        console.log(month)
        console.log(year)

        try {
          let res = await this.$api.post("/auth/requisitions/report/month", formData);
          console.log(res.status.toString())
          if (res.status.toString() === "200") {
            console.log("we are here")
            console.log(res.data)
            const fileData = res.data;

            this.$swal.fire({
              icon: 'success',
              title: 'Reporte generado',
              text: 'El reporte se ha generado correctamente',
              confirmButtonText: 'Descargar',
              customClass: {
                popup: 'mySwal'
              }
            }).then((result) => {
              if (result.isConfirmed) {
                const byteCharacters = atob(fileData.file_data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                // Create download link
                const downloadLink = document.createElement('a');
                downloadLink.href = URL.createObjectURL(blob);
                console.log(fileData.file_name)
                downloadLink.download = fileData.file_name || 'reporte.xlsx';

                // Trigger download
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);

                // Clean up
                URL.revokeObjectURL(downloadLink.href);

              }
            })
          }
        }catch (error) {
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ha ocurrido un error al generar el reporte',
            customClass: {
              popup: 'mySwal'
            }
          })
        }

      }
    }
  },
  created() {
    this.getRequisitions()
    this.getDepartments()
  }

}
</script>

<template>
  <div id="section-0" class="container">

    <div class="userSearch">
      <h1>Requisiciones</h1>

      <div :class="sidebarData.includes('ad-prov-requisitions-reg') ? 'subOpt' : 'subOptCenter'">
        <div>
          <input type="text" v-model="search" placeholder="Buscar por código ...">
        </div>
        <div>
          <button role="link" @click="$router.push('/scene/register_requisitions')"
                  v-if="(sidebarData.includes('ad-prov-requisitions-reg'))"
                  :disabled="!(sidebarData.includes('ad-prov-requisitions-reg'))">Registrar nueva requisición
          </button>
        </div>
      </div>


      <div class="table-container mt-4" v-if="requisitions.length">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>#</th>
            <th>Código</th>
            <th>Departamento</th>
            <th>Fecha</th>
            <th>Opciones</th>


          </tr>

          </thead>
          <tbody>

          <tr v-for="(requisition, index) in filteredRequisitions" :key="requisition.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ requisition.code }}</td>
            <td>{{ getDepartmentsById(requisition.department).title }}</td>
            <td>{{ requisition.deliveredAt.substring(0, 10) }}</td>
            <td class="td_align_center">
              <button class="tableBtn" @click="showRequisition(requisition.id)" role="link">Ver</button>
            </td>
          </tr>

          </tbody>

        </table>
      </div>
      <div v-else>
        <p class="bordered-p">No hay requisiciones disponibles.</p>
      </div>

      <div>
        <button @click="getReport()">Generar reporte mensual</button>
      </div>


    </div>
  </div>


</template>


<style>

.subOpt {
  grid-template-columns: 1fr 1fr;
  display: grid;
  justify-content: space-between;
  gap: 20px;
  width: 800px;
  margin: auto;
}

</style>